import {
  prepareRequest
} from './request'

import SettingsManager from '../managers/settings'

export const getTranslations = async ({ lang, signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    method: 'GET',
    url: 'translations',
    query: {
      lang
    },
    signal
  })

  return request()
}

export const getNavigation = async ({ signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    url: 'navigation',
    signal
  })

  return request()
}

export const getWidgets = async ({ signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    url: 'widget-page',
    signal
  })

  return request()
}

export const getStaticBlock = async ({ source, lang, signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    method: 'GET',
    url: 'static-block',
    query: {
      name: source,
      lang
    },
    signal
  })

  return request()
}

export const getPage = async ({ lang, source, signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    url: 'page',
    method: 'GET',
    query: {
      name: source,
      lang
    },
    signal
  })

  return request()
}

export const getSiteSettings = async ({ signal = null }) => {
  const query = {}

  if (process.env.NODE_ENV === 'development') {
    // Disabling CMS settings catching
    query.nocache = true
  }

  const request = prepareRequest({
    method: 'GET',
    api: 'cms',
    url: 'cms-config',
    query,
    signal
  })

  return request()
}

export const getBanner = async ({ group, lang = 'ENG', signal = null }) => {
  const request = prepareRequest({
    api: 'cms',
    url: 'banner/list',
    method: 'GET',
    query: {
      group_id: group,
      lang
    },
    signal
  })

  return request()
}

export const getPromotionsList = ({ signal = null }) => {
  const lang = SettingsManager.settings.lang

  const request = prepareRequest({
    api: 'cms',
    method: 'GET',
    url: 'promotion/list',
    query: {
      lang
    },
    signal
  })

  return request()
}

export const getPromotion = ({ id, signal = null }) => {
  const lang = SettingsManager.settings.lang

  const request = prepareRequest({
    api: 'cms',
    method: 'GET',
    url: 'promotion',
    query: {
      lang,
      id
    },
    signal
  })

  return request()
}
